<template>
  <div id="app">
    <Navbar></Navbar>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>



<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
}
</script>


<style>
/* Bootstrap Scripts */
@import "https://stackpath.bootstrapcdn.com/bootstrap/4.1.2/css/bootstrap.min.css";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html {
    scroll-behavior: smooth;
}
body {
    font-family: 'Muli', sans-serif;
    color: #020202;
    text-align: center;
    font-weight: 200;
    overflow-x: hidden;
}
p, h1, h2, h4, h6 {
  cursor: default;
}
.top-bg {
    top: 2px;
    position: relative;
    z-index: -1;
    width: 100%;
    overflow: hidden;
}
.down-bg {
    bottom: 2px;
    position: relative;
    z-index: -1;
    width: 100%;
    overflow: hidden;
}
a, a:hover {
    text-decoration: none;
}

@media only screen and (max-width: 600px) {
  body {
    font-size: 0.9rem;
  }
}
</style>
